import React from 'react'
import styled from 'styled-components'

const StyledHeader = styled.div`
	padding: 4rem;
	div {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
	}
	h1 {
		margin: 0;
		margin-right: 2rem;
	}
	p {
		max-width: 450px;
		margin-top: 2rem;
		line-height: 1.5em;
	}
	@media(max-width: 500px) {
		padding: 2rem;
		font-size: 0.7em
		padding-bottom: 0;
	}
`

const Header = () => (
	<StyledHeader>
		<div>
			<h1>Lachie's Art</h1>
			<p>&copy; {(new Date()).getFullYear()}</p>
		</div>
		<p>I'm an artist based in <a target="_blank" href="https://www.google.com.au/maps/place/Newcastle+NSW/" rel="noopener noreferrer">Newcastle, Australia</a>.</p>
		<p>My work mainly consists of: digital, glitch, collage, CGI, 3D, and AI.</p>
	</StyledHeader>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js